import { render, staticRenderFns } from "./BynderMetadataModal.vue?vue&type=template&id=61fed22a"
import script from "./BynderMetadataModal.vue?vue&type=script&lang=js"
export * from "./BynderMetadataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports